import onGetMonthlyRecord from './onGetMonthlyRecord';
import onGetExemptionCategories from './onGetExemptionCategories';
import onGetIsExpansionPlan from './onGetIsExpansionPlan';
import onCreateExemption from './onCreateExemption';
import onUpdateExemption from './onUpdateExemption';
import onArchiveExemption from './onArchiveExemption';
import onRestoreExemption from './onRestoreExemption';
import onUploadCeDocument from './onUploadCeDocument';
import onRefreshMonthlyRecord from './onRefreshMonthlyRecord';
import onCreateEntry from './onCreateEntry';
import onUpdateEntry from './onUpdateEntry';
import onArchiveEntry from './onArchiveEntry';
import onRestoreEntry from './onRestoreEntry';
import onGetMonthlyTotals from './onGetMonthlyTotals';
import onGetArchivedPlanRecord from './onGetArchivedPlanRecord';

export default {
  onGetMonthlyRecord,
  onGetExemptionCategories,
  onGetIsExpansionPlan,
  onCreateExemption,
  onUpdateExemption,
  onArchiveExemption,
  onRestoreExemption,
  onUploadCeDocument,
  onRefreshMonthlyRecord,
  onCreateEntry,
  onUpdateEntry,
  onArchiveEntry,
  onRestoreEntry,
  onGetMonthlyTotals,
  onGetArchivedPlanRecord,
};
